import { Action } from 'redux';
import { PrepopulatedFields } from '../../interfaces/prepopulated-fields.interface';
import { PrePopulatedDataStateStructure } from '../interfaces/prePopulatedDataStateStructure.interface';

export const PRE_POPULATED_DATA_STATE_NAME = 'PrePopulateData';

const INITIAL_STATE: PrePopulatedDataStateStructure = {
  prepopulatedFields: {
    firstName: '',
    middleInitial: '',
    lastName: '',
    dob: '',
    gender: '',
    addressLine1: '',
    addressLine2: '',
    city: '',
    personalPhoneNumber: '',
    emailAddress: '',
    mailingAddressExists: '',
    mailingAddressLine1: '',
    mailingAddressLine2: '',
    mailingCity: '',
    mailingState: '',
    mailingZipCode: '',
    memberIdNumber: '',
    zipCode: '',
    state: '',
    effectiveStartDate: '',
    effectiveEndDate: '',
    memberLookup: {
      AGREEMENTID: '',
      MEMBERIDENTIFICATIONNUM: '',
      FULLNAME: '',
      APPLICATIONID: '',
      BIRTHDATE: '',
      FIRSTNAME: '',
      GENDER: '',
      HICNUMBER: '',
      HOMEPHONE: '',
      LASTNAME: '',
      MIDDLEINITIAL: '',
      GROUPNUM: '',
      SUFFIX: '',
      PERMCITY: '',
      PERMSTATE: '',
      PERMSTREET1: '',
      PERMSTREET2: '',
      PERMZIP: '',
      PERMZIPEXTN: '',
      MBRSSNID: '',
      GROUPNUMS: [],
      ISCURRENTMEMBER: false,
      DDVALUE: '',
      ACTIVEGRPINSURANCE: false,
      APPLICANTEMPLOYEDIND: false,
      CDROMCHECKBOX: false,
      DRUGINSBYINDIVIDUALPLAN: false,
      DRUGINSBYSPSPLAN: false,
      EFFECTIVESTARTDATE: '',
      EFFECTIVEENDDATE: '',
      FEDERALBLKLUNGCOV: false,
      OTHERINSDENTALVISIONCOV: false,
      OTHERINSDIRECTPAY: false,
      OTHERINSMEDRXCOV: false,
      OTHERINSMEDRXCOVONLY: false,
      OTHERINSMEDICALCOV: false,
      PERMCOUNTY: '',
      PERMCOUNTYNAME: '',
      PLANID: '',
      PLANNAME: '',
      PLANIDDESCRIPTION: '',
      READANDAGREE: false,
      RETIRECOVERAGE: false,
      SELECTPLANID: '',
      SELECTPLANIDDESCRIPTION: '',
      SUPPLEMENTALCOVERAGE: false,
      VETERANADMINCOV: false,
      WORKERSCOMPENSATIONIND: false,
      RETRIEVEAPPLICATIONOUT: [],
      TELESALESIND: '',
      PBPSEGMENTID: '',
    },
    linkShare: {
      agencyID: null,
      agentID: null,
      agentACSId: null,
      subject: null,
      urlKey: null
    }
  }
}

const INIT_PREPOPULATED_DATA = 'INIT_PREPOPULATED_DATA';
const SAVE_PREPOPULATED_DATA = 'SAVE_PREPOPULATED_DATA';

export class PrePopulatedDataAppAction implements Action {
  type: string;
  prepopulatedFields: PrepopulatedFields;
}

export function savePrepopulatedData(prePopFields: PrepopulatedFields) {
  return {
    type: SAVE_PREPOPULATED_DATA,
    prepopulatedFields: prePopFields
  };
}

/**
 * Login info reducers
 */
export function PrePopulateData(state: PrePopulatedDataStateStructure = INITIAL_STATE, action: PrePopulatedDataAppAction) {
  const copiedState = JSON.parse(JSON.stringify(Object.assign({}, state)));
  switch (action.type) {
    case SAVE_PREPOPULATED_DATA:
      copiedState.prepopulatedFields = action.prepopulatedFields;
      return Object.assign({}, state, copiedState);
    case INIT_PREPOPULATED_DATA:
    default:
      return state;
  }
}
